export { default as translations } from './translations.json';

/**
 * Get group ID from user.
 * @param {Object|null} user
 * @returns {string|null}
 */
export const getUserGroupId = (user) =>
  user?.attributes?.publicData?.groupId || null;

/**
 * Check if user belongs to a specific group.
 * @param {Object|null} user
 * @param {string} groupId
 * @returns {boolean}
 */
export const isInGroup = (user, groupId) =>
  getUserGroupId(user) === groupId;
